import { Box, Typography } from '@mui/material';
import { useProgramTypeContext } from '../useProgramTypesContext';

const NoProgramDeliverableData = () => {
  const { payload } = useProgramTypeContext();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {!payload.id
          ? 'Please select program to view deliverable types.'
          : 'No Items found.'}
      </Typography>
      <Typography color="text.secondary">
        {!payload.id ? '' : 'Add new deliverable type to view here.'}
      </Typography>
    </Box>
  );
};

export default NoProgramDeliverableData;
